import React, { useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Footer } from './Footer';
import { Sidebar } from '../Sidebar/Sidebar';
import { NavHeader } from './NavHeader';

interface LayoutProps {
  showDesktopSidebar?: boolean;
  desktopSidebar?: React.ReactNode;
}

export function Layout({ showDesktopSidebar = false, desktopSidebar }: LayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/';

  // Bestem NavHeader variant basert på om vi har desktop sidebar
  const navHeaderVariant = showDesktopSidebar ? 'light' : (isHome ? 'transparent' : 'dark');

  return (
    <div className={`min-h-screen ${isHome ? 'bg-condo-dark' : 'bg-gray-50'} overflow-x-hidden w-full ${showDesktopSidebar ? 'lg:flex' : ''}`}>
      {/* NavHeader for alle breakpoints */}
      <NavHeader variant={navHeaderVariant} onMenuClick={() => setIsSidebarOpen(true)} />

      {/* Desktop Sidebar (kun hvis showDesktopSidebar er true) */}
      {showDesktopSidebar && (
        <div className="hidden lg:block">
          {desktopSidebar}
        </div>
      )}

      {/* Mobile Sidebar (global hamburger menu) */}
      <Sidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      {/* Main content */}
      <main className={showDesktopSidebar ? "lg:flex-1 pt-20 lg:ml-48 2xl:ml-64" : "w-full"}>
        <div className={showDesktopSidebar 
          ? "max-w-screen-sm mx-auto sm:max-w-none w-full px-4 sm:px-6 lg:px-8"
          : "max-w-screen-sm mx-auto sm:max-w-none w-full"
        }>
          <Outlet />
        </div>
      </main>

      {/* Footer - vis på mobil for alle sider, skjul på desktop for Admin/Styret */}
      <div className="lg:hidden">
        <Footer />
      </div>
      {!showDesktopSidebar && (
        <div className="hidden lg:block">
          <Footer />
        </div>
      )}
    </div>
  );
}